import { Clock, Trash2, Users } from "@tamagui/lucide-icons";
import { observer } from "mobx-react-lite";
import type React from "react";
import { Text, View, XStack } from "tamagui";
import { getDayJs } from "../../../core/dayJs";
import { usePlanNavigation } from "../../../plans/usePlanNavigation";
import { Block } from "../../../ui/Block";
import { Body } from "../../../ui/Body";
import { Label } from "../../../ui/Label";
import { PopoverConfirm } from "../../../ui/PopoverConfirm";
import { UserAvatar } from "../../../ui/UserAvatar";
import type ExpenseItemModule from "../data/ExpenseItemModel";
import type ExpenseModuleModel from "../ExpenseModuleModel";

export const ExpenseRow: React.FC<{
  module: ExpenseModuleModel;
  expense: ExpenseItemModule;
}> = observer(({ module, expense }) => {
  const navigation = usePlanNavigation();

  return (
    <Block
      infoRowItems={[
        {
          text: expense.splitsUser
            .map((split) => split.user?.data.displayName ?? "Unknown")
            .join(", "),
          icon: Users,
          trim: ", ",
        },
        {
          text: getDayJs(expense.data.timestamp),
          icon: Clock,
        },
      ]}
      onPress={() =>
        navigation.navigate("Module", {
          planUid: module.plan.uid,
          moduleUid: module.uid,
          dataUid: expense.uid,
        })
      }
      grouped
      icon={<UserAvatar userUid={expense.paidByUser?.uid} />}
    >
      <XStack
        width="100%"
        justifyContent="space-between"
        alignItems="center"
        gap="$larger"
      >
        <View flex={1}>
          {expense.data.title ? (
            <Text>
              <Body>
                {expense.paidByUser?.data.displayName} paid{" "}
                <Body color={"#e73333"}>
                  {module.currencyFormatter.format(
                    expense.data.amount.toNumber(),
                  )}
                </Body>{" "}
                for{" "}
              </Body>
              <Label>{`${expense.data.title}`}</Label>
            </Text>
          ) : (
            <Body>
              {expense.paidByUser?.data.displayName} paid{" "}
              <Body color={"#e73333"}>
                {module.currencyFormatter.format(
                  expense.data.amount.toNumber(),
                )}
              </Body>
            </Body>
          )}
        </View>
        <PopoverConfirm
          onConfirm={() => {
            const titleText = expense.data.title
              ? ` - ${expense.data.title}`
              : "";
            expense.deleteData(
              `expense paid by ${
                expense.paidByUser?.data.displayName
              }${titleText} (${module.currencyFormatter.format(
                expense.data.amount.toNumber(),
              )})`,
            );
          }}
        >
          <Trash2 size={"$size.normal"} color={"$muted"} />
        </PopoverConfirm>
      </XStack>
    </Block>
  );
});
